module.exports = __webpack_public_path__ + "static/img/bg9.29c66cc8.png";